import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { authGuard } from '../shared/auth/guards/auth.guard';
import { loggedInGuard } from '../shared/auth/guards/logged-in.guard';
import { loggedInRoutes } from './base-template/dashboard/logged-in-user.routes';
import { BaseTemplateComponent } from './base-template/base-template.component';
import { redirectGuard } from './redirect.guard';
import { DashboardComponent } from './base-template/dashboard/dashboard.component';

export const routes: Routes = [
  { path: '', canActivate: [redirectGuard], pathMatch: 'full', component: DashboardComponent },
  {
    path: '',
    children: [
      { path: 'login', component: LoginComponent, canActivate: [loggedInGuard], },
      { path: 'register', component: RegisterComponent, canActivate: [loggedInGuard] },
      {
        path: 'app',
        component: BaseTemplateComponent,
        children: loggedInRoutes,
        canActivate: [authGuard],
      }
    ],
  },
  { path: '**', component: BaseTemplateComponent },
];
